import { useState, useEffect } from "react";
import { trackEvent } from "../utils/analytics";
import PdfViewer from "../components/PdfViewer";

const Resume = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Track analytics events
    trackEvent("resume_page_view", {
      event_category: "Navigation",
      event_label: "Visited Resume Page",
    });
    trackEvent("resume_preview_loaded", {
      event_category: "Resume",
      event_label: "Resume PDF Preview Displayed",
    });
    setLoading(false);
  }, []);

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 px-4 py-12 max-w-3xl mx-auto transition-colors duration-300">
      {/* Header */}
      <div className="border-b-2 border-slate-900 dark:border-slate-600 pb-6 mb-8">
        <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-100 mb-2">
          Resume
        </h1>
        {loading ? (
          <p className="text-sm font-mono text-slate-500 dark:text-slate-400">Loading...</p>
        ) : (
          <p className="text-sm font-mono text-slate-600 dark:text-slate-400">
            Current version
          </p>
        )}
      </div>

      {/* PDF Viewer */}
      {!loading && (
        <PdfViewer url="/resume.pdf" title="James Munji - Resume" />
      )}

      {loading && (
        <div className="flex items-center justify-center min-h-[600px]">
          <div className="text-center">
            <div className="animate-pulse mb-3 text-4xl">📄</div>
            <p className="text-sm font-mono text-slate-600">Loading resume...</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Resume;
